import React, { useEffect, useState, useRef } from "react";
import ApiClient from "../ApiClient";
import { ClipboardList, Loader2 } from "lucide-react";
import ms from "ms";
import moment from "moment";
import "../css/Dailystatus.css";
import { useSelector } from "react-redux";
import { selectProjects } from "src/stores/projectSlice";
import { selectUser } from "src/stores/userSlice";
import Tooltip from "@mui/material/Tooltip";
import { notify } from "../utils/ToastUtils";
import { Plus, Trash2, Send, Edit, CalendarDays,
     CalendarCheck, Eraser, X, FileText, CheckCircle2,
      ChevronLeft, ChevronRight, AlertTriangle, ChevronDown,
       ChevronUp } from "lucide-react";
import AddTaskModal from "../components/AddTaskModal";
import { StatCardSkeleton, CalendarSkeleton, ListCardSkeleton } from "../components/PageSkeletonLoaders";
import { AppContext } from "src/stores/ContextProvider";
import { useContext } from "react";
import SubmitDsrConfirmDialog from "../components/SubmitDsrConfirmDialog";
import ActionConfirmModal from "../components/ActionConfirmModal";
import { useLocation, useNavigate } from "react-router-dom";

export default function Compose(props) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmTitle, setConfirmTitle] = useState("");
  const [confirmMessage, setConfirmMessage] = useState("");
  const [selectedOptions2, setSelectedOptions2] = useState();
  const [activeSidebarTab, setActiveSidebarTab] = useState('calendar'); // 'calendar' or 'missed'
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const projects = useSelector(selectProjects);
  const user = useSelector(selectUser);
  const { officeHolidays } = useContext(AppContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const queryDate = searchParams.get('date');

    if (location.state?.date) {
      setState(prev => ({ ...prev, inputDate: moment(location.state.date).format("YYYY-MM-DD") }));
    } else if (queryDate) {
      setState(prev => ({ ...prev, inputDate: moment(queryDate).format("YYYY-MM-DD") }));
      // Clean up the URL by removing the query string, keeping only the pathname
      navigate(location.pathname, { replace: true, state: location.state });
    }

    if (location.state?.openModal) {
      setModal(true);
      setModalHeading("Add");
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.search, location.state?.date, location.state?.openModal, navigate, location.pathname]);
  const [modalHeading, setModalHeading] = useState("Add");
  const [index, setIndex] = useState();
  const [minDate, setMinDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);
  const [allDsr, setAllDsr] = useState([]);
  const [absentDsr, setAbsentDsr] = useState([]);
  const [allLeaves, setAllLeaves] = useState([]);
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [calendarDate, setCalendarDate] = useState(new Date());
  const sortedProjects = projects
    .slice()
    .sort((a, b) =>
      a.PROJECT_NAME > b.PROJECT_NAME
        ? 1
        : b.PROJECT_NAME > a.PROJECT_NAME
        ? -1
        : 0
    )
    .filter((el) => el.PROJECT_STATUS === "Open");
  const [state, setState] = useState({
    employeeCode: user?.emp_code,
    projectCode: [],
    inputDate: moment(new Date()).format("YYYY-MM-DD"),
    dsr: [],
    bcc: user?.mail,
    SubmissionDate: moment(new Date()).format("YYYY-MM-DD"),
    reportID: "",
    taskID: "",
    type: "",
  });

  const [subTaskArray, setSubTaskArray] = useState([]);
  const [expandedTaskIndex, setExpandedTaskIndex] = useState(null);
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, index: null });
  const [clearModal, setClearModal] = useState(false);

  useEffect(() => {
    if (state.dsr?.length === 1) {
      setExpandedTaskIndex(0);
    } else {
      setExpandedTaskIndex(null);
    }
  }, [state.dsr?.length]);
  // const [clientCode,setClientCode] = useState([])

  const getClientCode = (prjCode) => {
    let clientCode = [];
    for (let i = 0; i < prjCode.length; i++) {
      const client = projects.find((item) => item.PROJECT_CODE === prjCode[i]);
      clientCode.push(client?.CLIENT_CODE);
    }

    return clientCode;
  };

  const getProject = (code) => {
    const project = projects.find((item) => item.PROJECT_CODE === code);
    return project?.PROJECT_NAME;
  };
  const executeSendDsr = async (e) => {
    setLoading(true);
    if (state.dsr.length === 0) {
      notify.error("Please add atleast one task");
      return;
    }

    if (
      state.projectCode.length === 0 ||
      state.bcc === "" ||
      state.inputDate === "" ||
      state.subject === ""
    ) {
      notify.error("Date can't be left empty");
      return;
    }

    var totHrs = state.dsr.reduce((el, currentValue) => {
      return el + Number(currentValue.hours);
    }, 0);

    if (totHrs > 12) {
      notify.error("Total worked hours should not exceed 12 hours");
      return;
    }
    let projectCodes = state.dsr.map(t => t.projectCode);
    let client = getClientCode(projectCodes);
    let prjName = projectCodes.map(code => getProject(code));
    try {
        setShowConfirm(false);
      const { data } = await ApiClient.post(
        `${process.env.REACT_APP_BASE_URL}/dsr/sendDsr`,
        {
          project: projectCodes,
          projectName: prjName,
          clientCode: client,
          subject:
            "DSR-" +
            user?.name +
            "-" +
            moment(state.inputDate).format("DD-MMM-YYYY"),
          date: state.inputDate,
          dsr: state.dsr,
          empCode: user?.emp_code,
          empMail: user?.mail,
          submissionDate: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
          bcc: state.bcc,
          type: state.type,
          reportID: state.reportID,
          taskID: state.taskID,
        }
      );
      setState((prevState) => ({
        ...prevState,
        projectCode: [],
        inputDate: moment(new Date()).format("YYYY-MM-DD"),
        dsr: [],
        type: "",
      }));
      setShowConfirm(false);
      setSubTaskArray([]);
      notify.success("DSR sent successfully");
      await getHistoryData();
      setLoading(false);
    } catch (error) {
      // console.log(error)
      const data = error?.response?.data;
      let errmsg =
      data?.message ||
      data?.error?.sqlMessage ||   // ✅ check this BEFORE plain error
      data?.error ||
      data?.msg ||
      data?.detail ||
      (error?.response
        ? `${error?.response?.status} - ${error?.response?.statusText}`
        : "Something went wrong. Please try again later");
      notify.error(errmsg);
      setLoading(false);
    }
  };

  const sendDsr = async (e) => {
    if (state.dsr.length === 0) {
      notify.error("Please add atleast one task");
      return;
    }

    if (
      state.projectCode.length === 0 ||
      state.bcc === "" ||
      state.inputDate === "" ||
      state.subject === ""
    ) {
      notify.error("Date can't be left empty");
      return;
    }

    var totHrs = state.dsr.reduce((el, currentValue) => {
      return el + Number(currentValue.hours);
    }, 0);
    if (totHrs > 12) {
      notify.error("Total worked hours should not exceed 12 hours");
      return;
    }

    const selectedDate = moment(state.inputDate).format("MMMM D, YYYY");

    if (moment(state.inputDate).isoWeekday() > 5) {
      setConfirmTitle("Submit DSR for Weekend?");
      setConfirmMessage(`${selectedDate} is a non-working day.\nDo you want to continue?`);
      setShowConfirm(true);
      return;
    }

    if (officeHolidays && officeHolidays.length > 0) {
      const isHoliday = officeHolidays.includes(state.inputDate);
      if (isHoliday) {
        setConfirmTitle("Submit DSR for Holiday?");
        setConfirmMessage(`${selectedDate} is marked as a holiday.\nDo you want to continue?`);
        setShowConfirm(true);
        return;
      }
    }

    try {
      setLoading(true);
      const { data } = await ApiClient.post(`${process.env.REACT_APP_BASE_URL}/dsr/checkLeave`, {
        empCode: user?.emp_code,
        date: state.inputDate
      });
      if (data.isLeave) {
        setConfirmTitle("Submit DSR for Leave Day?");
        setConfirmMessage(`You are on leave on ${selectedDate}.\nDo you want to continue?`);
        setShowConfirm(true);
        return;
      }
    } catch (error) {
      console.error("Failed to validate leave", error);
    }
    finally{
      setLoading(false);  
    }

    executeSendDsr(e);
  };

  const AddSubTask = (taskData) => {
    let updatedArray = [];
    if (modalHeading === "Add") {
      updatedArray = [...subTaskArray, taskData];
    } else {
      updatedArray = [...subTaskArray];
      updatedArray[index] = taskData;
    }
    setSubTaskArray(updatedArray);
    const prjCodeDef = updatedArray.map((e) => e.projectCode);
    setState({ ...state, dsr: updatedArray, projectCode: prjCodeDef });
    setModal(false);
  };

  const deleteSubTasks = (index) => {
    setDeleteModal({ isOpen: true, index });
  };

  const executeDeleteSubTask = () => {
    if (deleteModal.index === null) return;
    const updatedArray = subTaskArray.filter((_, i) => i !== deleteModal.index);
    setSubTaskArray(updatedArray);
    const prjCodeDef = updatedArray.map((e) => e.projectCode);
    setState({ ...state, dsr: updatedArray, projectCode: prjCodeDef });
    setDeleteModal({ isOpen: false, index: null });
  };

  const resetTasks = (e) => {
    setState((prevState) => ({ ...prevState, dsr: [], type: "" }));
    setSubTaskArray([]);
  };

  const handleCancelEdit = () => {
    setState({
      employeeCode: user?.emp_code,
      projectCode: [],
      inputDate: moment(new Date()).format("YYYY-MM-DD"),
      dsr: [],
      bcc: user?.mail,
      SubmissionDate: moment(new Date()).format("YYYY-MM-DD"),
      reportID: "",
      taskID: "",
      type: "",
    });
    setSubTaskArray([]);
  };

  const editSubTasks = (e, index) => {
    setSelectedOptions2({
      value: `${e.projectCode},${e.projectName}`,
      label: e.projectName,
    });
    setModalHeading("Edit");
    setIndex(index);
    setModal(true);
  };

  const PrjList = sortedProjects.map((prjcts) => ({
    value: prjcts.PROJECT_CODE,
    label: prjcts.PROJECT_NAME,
  }));
  const PrjListOption = PrjList.map((ele) => ({
    value: `${ele.value},${ele.label}`,
    label: ele.label,
  }));
  const modalOpen = () => {
    setSelectedOptions2([]);
    setModal(true);
  };

  const initDateRange = () => {
    const minsec = ms("29d");
    const min_date = new Date(+new Date(state.inputDate) - minsec);
    const max_date = new Date(new Date());
    setMinDate(moment(min_date).format("YYYY-MM-DD"));
    setMaxDate(moment(max_date).format("YYYY-MM-DD"));
  };
  const resetUpdateData = () => {
    setState({
      ...state,
      employeeCode: "",
      projectCode: [],
      inputDate: "",
      dsr: [],
      bcc: "",
      SubmissionDate: "",
      reportID: "",
      taskID: "",
      type: "",
    });

    setSubTaskArray([]);

    return;
  };
  const initTaskData = (report) => {
    resetUpdateData();
    
    const editingTasks = (report.tasks || []).map(task => ({
      taskId: task.TASK_ID,
      projectCode: task.PROJECT_CODE,
      projectName: getProject(task.PROJECT_CODE),
      taskName: task.TASK_NAME,
      domain: task.DOMAIN || "Application Development",
      description: task.TASK_DESC,
      status: task.COMPLETION_STATUS,
      hours: task.HOURS_SPENT,
      taskType: task.TASK_TYPE,
    }));
    
    setSubTaskArray(editingTasks);
    setState({
      ...state,
      employeeCode: user?.emp_code,
      projectCode: [...new Set(editingTasks.map(t => t.projectCode))],
      inputDate: report.STATUS_DATE,
      dsr: editingTasks,
      bcc: user?.mail,
      SubmissionDate: moment(new Date()).format("YYYY-MM-DD"),
      reportID: report.REPORT_ID,
      taskID: "",
      type: "edit",
      typeType: ""
    });
  };

  useEffect(() => {
    if (Object.keys(props.task).length > 0) {
      initTaskData(props.task);
    }
  }, [props.task]);

  const isMounted = useRef(true);
  
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    initDateRange();
    getHistoryData();
  }, []);

  const getHistoryData = async () => {
    try {
      setIsFetchingData(true);
      const startDate = moment().subtract(30, "days").format("YYYY-MM-DD");
      const endDate = moment().format("YYYY-MM-DD");
      const [dsrRes, absentRes, leaveRes] = await Promise.all([
        ApiClient.get(`${process.env.REACT_APP_BASE_URL}/dsr/getAllDsr`, {
          params: { startDate, endDate }
        }),
        ApiClient.get(`${process.env.REACT_APP_BASE_URL}/dsr/getAbsentDsr?start_date=${startDate}&end_date=${moment().format("YYYY-MM-DD")}`),
        ApiClient.post(`${process.env.REACT_APP_BASE_URL}/leave/getMyLeaveData`, {
          code: user?.emp_code,
          startDt: startDate,
          endDt: endDate
        }).catch(() => ({ data: [] }))
      ]);
      
      if (!isMounted.current) return;
      
      setAllDsr(Array.isArray(dsrRes.data) ? dsrRes.data : []);
      setAbsentDsr(Array.isArray(absentRes.data) ? absentRes.data : []);
      setAllLeaves(Array.isArray(leaveRes.data) ? leaveRes.data : []);
    } catch (err) {
      if (isMounted.current) {
        console.error("Failed to fetch history data", err);
      }
    } finally {
      if (isMounted.current) {
        setIsFetchingData(false);
      }
    }
  };

 const taskTypeMap = {
  "Application Development": [
    "01-Requirement Gathering / Analysis",
    "02-Architecture / Design / Wireframe",
    "03-Coding / Development - New",
    "04-Coding / Development - Rework",
    "05-Unit Testing / Validation",
    "06-System Integration Testing",
    "07-Bug Fixing",
    "08-Deployment",
    "09-Learning / Research / Evaluation",
    "10-Documentation",
    "11-Knowledge Transfer",
    "12-Production Run",
    "13-Status calls / Meetings / Discussions",
    "14-Interview Preparation / Hiring & Interview Support",
  ],

  "DevOps & Infra": [
    "21-Requirement Gathering / Analysis",
    "22-Infrastructure Planning & Design / Wireframe",
    "23-CI/CD Pipeline Development",
    "24-Infrastructure as Code (IaC)",
    "25-Configuration & Environment Rework",
    "26-Code / Configurations Review and Testing Validation",
    "27-Security Hardening & Compliance",
    "28-Monitoring & Observability Setup",
    "29-Softwares & Application Installation /Reinstallation/Upgrades",
    "30-Production Run / Health Monitoring",
    "31-Troubleshooting & Incident Support",
    "32-Maintenance & Optimization",
    "33-Knowledge Transfer / Documentation & Runbooks",
    "34-Status calls / Meetings / Discussions",
    "35-Interview Preparation / Hiring & Interview Support",
  ],

  "Data Engineering": [
    "41-Requirement Gathering / Analysis",
    "42-Data Discovery & Pipeline Design / Wireframe",
    "43-Data Pipeline Development - New",
    "44-Database & Warehouse Structuring",
    "45-Data Pipeline Maintenance & Rework",
    "46-Curation Script Development / Enhancement",
    "47-Data Quality Scripts & Validation Checks",
    "48-SQL Code Reviews / Unit Testing / System Testing",
    "49-Data Visualization Development",
    "50-Dashboard Maintenance, Validation & Delivery",
    "51-Data Loads / Production Run / Health Monitoring",
    "52-Troubleshooting / Bug Fixing",
    "53-Performance Tuning & Optimization",
    "54-Knowledge Transfer / Documentation & Metadata",
    "55-Status calls / Meetings / Discussions",
    "56-Interview Preparation / Hiring & Interview Support",
  ]
};
  const taskTypeOptions = [
  // Application Development
  { value: "01-Requirement Gathering / Analysis", label: "Requirement Gathering / Analysis" },
  { value: "02-Architecture / Design / Wireframe", label: "Architecture / Design / Wireframe" },
  { value: "03-Coding / Development - New", label: "Coding / Development - New" },
  { value: "04-Coding / Development - Rework", label: "Coding / Development - Rework" },
  { value: "05-Unit Testing / Validation", label: "Unit Testing / Validation" },
  { value: "06-System Integration Testing", label: "System Integration Testing" },
  { value: "07-Bug Fixing", label: "Bug Fixing" },
  { value: "08-Deployment", label: "Deployment" },
  { value: "09-Learning / Research / Evaluation", label: "Learning / Research / Evaluation" },
  { value: "10-Documentation", label: "Documentation" },
  { value: "11-Knowledge Transfer", label: "Knowledge Transfer" },
  { value: "12-Production Run", label: "Production Run" },
  { value: "13-Status calls / Meetings / Discussions", label: "Status calls / Meetings / Discussions" },
  { value: "14-Interview Preparation / Hiring & Interview Support", label: "Interview Preparation / Hiring & Interview Support" },

  // DevOps & Infra
  { value: "21-Requirement Gathering / Analysis", label: "Requirement Gathering / Analysis" },
  { value: "22-Infrastructure Planning & Design / Wireframe", label: "Infrastructure Planning & Design / Wireframe" },
  { value: "23-CI/CD Pipeline Development", label: "CI/CD Pipeline Development" },
  { value: "24-Infrastructure as Code (IaC)", label: "Infrastructure as Code (IaC)" },
  { value: "25-Configuration & Environment Rework", label: "Configuration & Environment Rework" },
  { value: "26-Code / Configurations Review and Testing Validation", label: "Code / Configurations Review and Testing Validation" },
  { value: "27-Security Hardening & Compliance", label: "Security Hardening & Compliance" },
  { value: "28-Monitoring & Observability Setup", label: "Monitoring & Observability Setup" },
  { value: "29-Softwares & Application Installation /Reinstallation/Upgrades", label: "Softwares & Application Installation /Reinstallation/Upgrades" },
  { value: "30-Production Run / Health Monitoring", label: "Production Run / Health Monitoring" },
  { value: "31-Troubleshooting & Incident Support", label: "Troubleshooting & Incident Support" },
  { value: "32-Maintenance & Optimization", label: "Maintenance & Optimization" },
  { value: "33-Knowledge Transfer / Documentation & Runbooks", label: "Knowledge Transfer / Documentation & Runbooks" },
  { value: "34-Status calls / Meetings / Discussions", label: "Status calls / Meetings / Discussions" },
  { value: "35-Interview Preparation / Hiring & Interview Support", label: "Interview Preparation / Hiring & Interview Support" },

  // Data Engineering
  { value: "41-Requirement Gathering / Analysis", label: "Requirement Gathering / Analysis" },
  { value: "42-Data Discovery & Pipeline Design / Wireframe", label: "Data Discovery & Pipeline Design / Wireframe" },
  { value: "43-Data Pipeline Development - New", label: "Data Pipeline Development - New" },
  { value: "44-Database & Warehouse Structuring", label: "Database & Warehouse Structuring" },
  { value: "45-Data Pipeline Maintenance & Rework", label: "Data Pipeline Maintenance & Rework" },
  { value: "46-Curation Script Development / Enhancement", label: "Curation Script Development / Enhancement" },
  { value: "47-Data Quality Scripts & Validation Checks", label: "Data Quality Scripts & Validation Checks" },
  { value: "48-SQL Code Reviews / Unit Testing / System Testing", label: "SQL Code Reviews / Unit Testing / System Testing" },
  { value: "49-Data Visualization Development", label: "Data Visualization Development" },
  { value: "50-Dashboard Maintenance, Validation & Delivery", label: "Dashboard Maintenance, Validation & Delivery" },
  { value: "51-Data Loads / Production Run / Health Monitoring", label: "Data Loads / Production Run / Health Monitoring" },
  { value: "52-Troubleshooting / Bug Fixing", label: "Troubleshooting / Bug Fixing" },
  { value: "53-Performance Tuning & Optimization", label: "Performance Tuning & Optimization" },
  { value: "54-Knowledge Transfer / Documentation & Metadata", label: "Knowledge Transfer / Documentation & Metadata" },
  { value: "55-Status calls / Meetings / Discussions", label: "Status calls / Meetings / Discussions" },
  { value: "56-Interview Preparation / Hiring & Interview Support", label: "Interview Preparation / Hiring & Interview Support" },
];


const domainOptions = [
  { value: "Application Development", label: "Application Development" },
  { value: "DevOps & Infra", label: "DevOps & Infra" },
  { value: "Data Engineering", label: "Data Engineering" },
];
  

    const nextMonth = () => setCalendarDate(moment(calendarDate).add(1, 'month').toDate());
    const prevMonth = () => setCalendarDate(moment(calendarDate).subtract(1, 'month').toDate());

    const generateCalendarDays = () => {
        const startDay = moment(calendarDate).startOf('month').startOf('week');
        const endDay = moment(calendarDate).endOf('month').endOf('week');
        const calendar = [];
        let day = startDay.clone().subtract(1, 'day');
        while (day.isBefore(endDay, 'day')) {
            calendar.push(
                Array(7).fill(0).map(() => day.add(1, 'day').clone())
            );
        }
        return calendar;
    };

    const calendarWeeks = generateCalendarDays();

    const getDsrStatus = (dateObj) => {
        const dateStr = dateObj.format('YYYY-MM-DD');
        if (dateObj.isAfter(moment(), 'day')) return null;
        // if (officeHolidays && officeHolidays.includes(dateStr)) return null;
        // if (dateObj.isoWeekday() > 5) return null; // Weekend
        
        const isAbsent = absentDsr.some(a => moment(a.DATE).format('YYYY-MM-DD') === dateStr);
        if (isAbsent) return "Missed";

        const hasSubmitted = allDsr.some(d => moment(d.STATUS_DATE).format('YYYY-MM-DD') === dateStr);
        if (hasSubmitted) return "Submitted";

        return null;
    };

    const submittedDays = new Set(allDsr?.map(item => moment(item.STATUS_DATE).format('YYYY-MM-DD'))).size;
    const missedDays = absentDsr.length;
    const isCurrentDateSubmitted = getDsrStatus(moment(state.inputDate)) === 'Submitted' && state?.type !== "edit";

    const getWorkingDaysInLast30Days = () => {
        let count = 0;
        const startDate = moment().subtract(30, 'days');
        const endDate = moment();
        let currentDay = startDate.clone();
        
        while (currentDay.isSameOrBefore(endDate, 'day')) {
            if (currentDay.isoWeekday() <= 5) {
                const dateStr = currentDay.format('YYYY-MM-DD');
                if (!officeHolidays || !officeHolidays.includes(dateStr)) {
                    count++;
                }
            }
            currentDay.add(1, 'day');
        }
        return count;
    };
    
    const totalWorkingDaysThisMonth = getWorkingDaysInLast30Days();
    
    const leaveTakenThisMonth = allLeaves
        // .filter(l => l.LEAVE_STATUS === 'Accept')
        ?.reduce((sum, l) => sum + (Number(l.NO_OF_DAYS) || 0), 0);

  return (
    <div className="flex flex-col gap-3">
        {/* Top Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
            {isFetchingData ? (
                <>
                    <StatCardSkeleton />
                    <StatCardSkeleton />
                    <StatCardSkeleton />
                    <StatCardSkeleton />
                </>
            ) : (
                <>
            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-2xl bg-blue-50 text-blue-500 flex items-center justify-center shrink-0">
                    <CalendarDays className="w-5 h-5" />
                </div>
                <div>
                    <h4 className="text-[11px] font-bold text-slate-500 uppercase tracking-wider mb-0.5">Working Days</h4>
                    <div className="flex items-end gap-1.5">
                        <span className="text-xl font-bold text-slate-800 leading-none">{totalWorkingDaysThisMonth}</span>
                    </div>
                    <p className="text-[10px] font-medium text-slate-400 mt-1">Last 30 Days</p>
                </div>
            </div>

            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-2xl bg-orange-50 text-orange-500 flex items-center justify-center shrink-0">
                    <CalendarCheck className="w-5 h-5" />
                </div>
                <div>
                    <h4 className="text-[11px] font-bold text-slate-500 uppercase tracking-wider mb-0.5">Leave Taken</h4>
                    <div className="flex items-end gap-1.5">
                        <span className="text-xl font-bold text-slate-800 leading-none">{leaveTakenThisMonth}</span>
                    </div>
                    <p className="text-[10px] font-medium text-slate-400 mt-1">Last 30 Days</p>
                </div>
            </div>

            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-2xl bg-indigo-50 text-indigo-500 flex items-center justify-center shrink-0">
                    <FileText className="w-5 h-5" />
                </div>
                <div>
                    <h4 className="text-[11px] font-bold text-slate-500 uppercase tracking-wider mb-0.5">DSR Submitted</h4>
                    <div className="flex items-end gap-1.5">
                        <span className="text-xl font-bold text-slate-800 leading-none">{submittedDays} <span className="text-sm font-medium text-slate-600">Days</span></span>
                    </div>
                    <p className="text-[10px] font-medium text-slate-400 mt-1">Last 30 Days</p>
                </div>
            </div>

            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-2xl bg-rose-50 text-rose-500 flex items-center justify-center shrink-0">
                    <AlertTriangle className="w-5 h-5" />
                </div>
                <div>
                    <h4 className="text-[11px] font-bold text-slate-500 uppercase tracking-wider mb-0.5">Missed DSRs</h4>
                    <div className="flex items-end gap-1.5">
                        <span className="text-xl font-bold text-slate-800 leading-none">{missedDays}</span>
                    </div>
                    <p className="text-[10px] font-medium text-slate-400 mt-1">Last 30 Days</p>
                </div>
            </div>
            </>
            )}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-3 items-stretch">
            {/* Left Sidebar */}
            <div className="col-span-1 flex flex-col h-full">
                {isFetchingData ? (
                    <CalendarSkeleton />
                ) : (
                <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 h-full flex flex-col">
                    {/* Tabs */}
                    <div className="flex items-center gap-6 border-b border-slate-100 mb-4 pb-0">
                        <button 
                            className={`pb-3 text-[13px] font-bold relative transition-colors ${activeSidebarTab === 'calendar' ? 'text-orange-500' : 'text-slate-500 hover:text-slate-700'}`}
                            onClick={() => setActiveSidebarTab('calendar')}
                        >
                            Calendar
                            {activeSidebarTab === 'calendar' && (
                                <div className="absolute bottom-0 left-0 w-full h-[2px] bg-orange-500 rounded-t-full"></div>
                            )}
                        </button>
                        <button 
                            className={`pb-3 text-[13px] font-bold relative transition-colors flex items-center gap-2 ${activeSidebarTab === 'missed' ? 'text-orange-500' : 'text-slate-500 hover:text-slate-700'}`}
                            onClick={() => setActiveSidebarTab('missed')}
                        >
                            Missed DSRs
                            <span className="w-5 h-5 rounded-full bg-red-100 text-red-600 flex items-center justify-center text-[10px] font-bold">
                                {missedDays}
                            </span>
                            {activeSidebarTab === 'missed' && (
                                <div className="absolute bottom-0 left-0 w-full h-[2px] bg-orange-500 rounded-t-full"></div>
                            )}
                        </button>
                    </div>

                    {activeSidebarTab === 'calendar' && (
                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center justify-between mb-4">
                                <h4 className="text-[15px] font-bold text-slate-800 mb-0">{moment(calendarDate).format('MMMM YYYY')}</h4>
                                <div className="flex items-center gap-2">
                                    <div className="flex items-center">
                                        <button onClick={prevMonth} className="p-1 text-slate-400 hover:text-slate-700 hover:bg-slate-100 rounded-md transition-colors"><ChevronLeft className="w-4 h-4" /></button>
                                        <button onClick={nextMonth} className="p-1 text-slate-400 hover:text-slate-700 hover:bg-slate-100 rounded-md transition-colors"><ChevronRight className="w-4 h-4" /></button>
                                    </div>
                                     </div>
                            </div>
                            
                            <div className="grid grid-cols-7 gap-1 text-center mb-2">
                                {['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].map(day => (
                                    <div key={day} className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{day}</div>
                                ))}
                            </div>
                            
                            <div className="grid grid-cols-7 gap-1">
                                {calendarWeeks.map((week, wIdx) => 
                                    week.map((day, dIdx) => {
                                        const isCurrentMonth = day.month() === moment(calendarDate).month();
                                        const isToday = day.isSame(moment(), 'day');
                                        const isSelected = day.isSame(moment(state.inputDate), 'day');
                                        const status = getDsrStatus(day);
                                        
                                        const isBeforeLast30Days = day.isBefore(moment().subtract(30, 'days'), 'day');
                                        const isAfterToday = day.isAfter(moment(), 'day');
                                        const isDisabled = isBeforeLast30Days || isAfterToday || status === 'Submitted';
                                        
                                        return (
                                            <div key={`${wIdx}-${dIdx}`} className="flex flex-col items-center justify-center py-1">
                                                <button 
                                                    onClick={() => {
                                                        setState({ ...state, inputDate: day.format("YYYY-MM-DD") });
                                                        setCalendarDate(day.toDate());
                                                    }}
                                                    disabled={isDisabled}
                                                    className={`
                                                        w-7 h-7 rounded-full flex items-center justify-center text-[12px] font-semibold transition-all mb-1
                                                        ${isDisabled ? 'opacity-40 cursor-not-allowed text-slate-400 hover:bg-transparent' :
                                                          !isCurrentMonth ? 'text-slate-300' : 
                                                          isSelected ? 'bg-orange-500 text-white shadow-sm' : 
                                                          isToday ? 'bg-slate-100 text-slate-800' : 'text-slate-600 hover:bg-slate-50'}
                                                    `}
                                                >
                                                    {day.date()}
                                                </button>
                                                <div className="flex gap-0.5 h-1">
                                                    {status === 'Submitted' && <span className="w-1 h-1 rounded-full bg-emerald-500"></span>}
                                                    {status === 'Missed' && <span className="w-1 h-1 rounded-full bg-red-500"></span>}
                                                </div>
                                            </div>
                                        );
                                    })
                                )}
                            </div>
                            
                            <div className="flex items-center justify-center gap-4 mt-4 pt-3 border-t border-slate-100">
                                <div className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-emerald-500"></span><span className="text-[10px] font-medium text-slate-500">DSR Submitted</span></div>
                                <div className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-red-500"></span><span className="text-[10px] font-medium text-slate-500">Missed</span></div>
                            </div>
                        </div>
                    )}

                    {activeSidebarTab === 'missed' && (
                        <div className="flex flex-col gap-2 overflow-y-auto pr-1 max-h-[320px] scrollbar-thin scrollbar-thumb-slate-200 scrollbar-track-transparent">
                            {isFetchingData ? (
                                [1, 2, 3].map(i => (
                                    <div key={i} className="h-[60px] bg-slate-100 animate-pulse rounded-lg shrink-0 w-full mb-1"></div>
                                ))
                            ) : (
                                absentDsr.map((abs, idx) => (
                                    <div key={idx} className="flex items-center justify-between py-2 border-b border-slate-100 last:border-0 shrink-0">
                                        <div className="flex items-center gap-3">
                                            <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center text-red-500">
                                                <CalendarDays size={14} />
                                            </div>
                                            <div className="flex flex-col">
                                                <span className="text-[13px] font-bold text-slate-700">{moment(abs.DATE).format("DD MMM YYYY")}</span>
                                                <span className="text-[11px] font-medium text-slate-400">{moment(abs.DATE).format("dddd")}</span>
                                            </div>
                                        </div>
                                        <button 
                                            onClick={() => {
                                                setState({ ...state, inputDate: moment(abs.DATE).format("YYYY-MM-DD"), dsr: [] });
                                                setModalHeading("Add");
                                                modalOpen();
                                            }}
                                            className="text-[11px] font-bold text-red-500 hover:text-red-600 bg-red-50 hover:bg-red-100 px-3 py-1.5 rounded-lg transition-colors"
                                        >
                                            Submit DSR
                                        </button>
                                    </div>
                                ))
                            )}
                            
                            {!isFetchingData && absentDsr.length === 0 && (
                                <div className="flex flex-col items-center justify-center flex-1 py-8 text-center">
                                    <div className="w-12 h-12 rounded-full bg-emerald-50 text-emerald-500 flex items-center justify-center mb-3">
                                        <CheckCircle2 size={24} />
                                    </div>
                                    <span className="text-[14px] font-bold text-slate-700">All caught up!</span>
                                    <span className="text-[12px] font-medium text-slate-500 mt-1">No missed DSRs last 30 days</span>
                                </div>
                            )}
                        </div>
                    )}
                </div>
                )}
            </div>

            {/* Right side: Today's Tasks */}
            {isFetchingData ? (
                <div className="col-span-1 lg:col-span-3 h-full flex flex-col min-w-0">
                    <ListCardSkeleton rows={4} />
                </div>
            ) : (
            <div className="col-span-1 lg:col-span-3 bg-white rounded-2xl border border-slate-200 shadow-sm p-5 flex flex-col min-w-0 h-full">
                
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-5">
                    <div className="flex flex-col">
                        <h2 className="text-[18px] font-bold text-slate-800 leading-tight">
                            {!state.inputDate ? "Tasks" : moment(state.inputDate).isSame(moment(), 'day') ? "Today's Tasks" : `Tasks for ${moment(state.inputDate).format('DD MMM YYYY')}`}
                        </h2>
                        <p className="text-[13px] font-medium text-slate-500 mt-0.5">Add your tasks and submit your daily status</p>
                    </div>
                    
                    {state.dsr && state.dsr.length > 0 && 
                        <div className="flex items-center gap-3 w-full sm:w-auto">
                                <button 
                                    disabled={isCurrentDateSubmitted  || loading}
                                    onClick={() => modalOpen(setModalHeading("Add"))}
                                    className={`px-4 py-2 text-white text-[13px] font-bold rounded-lg flex items-center gap-2 shadow-sm transition-colors ${isCurrentDateSubmitted ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 shadow-blue-600/20'}`}
                                >
                                    <Plus size={16} strokeWidth={2.5} /> Add Task
                                </button>
                        </div>
                    }
                </div>

                <div className={`flex flex-col flex-1 overflow-hidden relative ${state.dsr && state.dsr.length > 0 ? "min-h-[250px] max-h-[250px]" : ""}`}>
                    {state.dsr && state.dsr.length > 0 ? (
                        <>
                            <div className="overflow-x-auto overflow-y-auto flex-1 scrollbar-thin scrollbar-thumb-slate-200 scrollbar-track-transparent border border-slate-200 rounded-lg">
                                <table className="w-full text-left border-collapse min-w-[800px]">
                                    <thead className="sticky top-0 z-10 bg-slate-50 border-b border-slate-200 shadow-sm">
                                        <tr>
                                            <th className="py-2.5 px-3 text-[11px] font-extrabold text-slate-700 uppercase tracking-wider whitespace-nowrap">#</th>
                                            <th className="py-2.5 px-3 text-[11px] font-extrabold text-slate-700 uppercase tracking-wider whitespace-nowrap">Task Details</th>
                                            <th className="py-2.5 px-3 text-[11px] font-extrabold text-slate-700 uppercase tracking-wider whitespace-nowrap">Project</th>
                                            <th className="py-2.5 px-3 text-[11px] font-extrabold text-slate-700 uppercase tracking-wider whitespace-nowrap">Task Type</th>
                                            <th className="py-2.5 px-3 text-[11px] font-extrabold text-slate-700 uppercase tracking-wider whitespace-nowrap">Hours</th>
                                            <th className="py-2.5 px-3 text-[11px] font-extrabold text-slate-700 uppercase tracking-wider whitespace-nowrap">Status</th>
                                            <th className="py-2.5 px-3 text-[11px] font-extrabold text-slate-700 uppercase tracking-wider whitespace-nowrap">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {state.dsr.map((task, index) => {
                                            const isExpanded = expandedTaskIndex === index;
                                            return (
                                            <React.Fragment key={index}>
                                            <tr 
                                                className={`border-b border-slate-100 hover:bg-slate-50/50 transition-colors cursor-pointer ${isExpanded ? 'bg-slate-50/30' : ''}`}
                                                onClick={() => setExpandedTaskIndex(isExpanded ? null : index)}
                                            >
                                                <td className="py-2 px-3 text-[13px] font-bold text-slate-500 align-top">
                                                    <div className="flex items-center gap-1.5 mt-0.5">
                                                        {isExpanded ? <ChevronUp size={14} className="text-slate-500" /> : <ChevronDown size={14} className="text-slate-500" />}
                                                        <span>{index + 1}</span>
                                                    </div>
                                                </td>
                                                <td className="py-2 px-3 align-top max-w-[250px]">
                                                    <Tooltip title={task.taskName} placement="top" arrow>
                                                        <h4 className="text-[13px] font-medium text-slate-700 mb-1 truncate block">{task.taskName}</h4>
                                                    </Tooltip>
                                                </td>
                                                <td className="py-2 px-3 align-top max-w-[150px]">
                                                    <Tooltip title={task.projectName} placement="top" arrow>
                                                        <div className="text-[13px] font-bold text-slate-700 truncate block">{task.projectName}</div>
                                                    </Tooltip>
                                                </td>
                                                <td className="py-2 px-3 align-top max-w-[120px]">
                                                    <Tooltip title={task.taskType} placement="top" arrow>
                                                        <div className="text-[12px] font-medium text-slate-600 truncate block">
                                                            {task.taskType}
                                                        </div>
                                                    </Tooltip>
                                                </td>
                                                <td className="py-2 px-3 text-[13px] font-bold text-slate-700 align-top">
                                                    {Number(task.hours).toFixed(1)}
                                                </td>
                                                <td className="py-2 px-3 align-top">
                                                    <span className={`inline-flex px-2.5 py-1 text-[11px] font-bold rounded-full border ${
                                                        task.status === "Completed" ? "bg-emerald-50 text-emerald-600 border-emerald-200" : 
                                                        (task.status === "In Progress" ? "bg-orange-50 text-orange-600 border-orange-200" : "bg-blue-50 text-blue-600 border-blue-200")
                                                    }`}>
                                                        {task.status}
                                                    </span>
                                                </td>
                                                <td className="py-2 px-3 align-top">
                                                    <div className="flex items-center gap-2">
                                                        <button 
                                                            onClick={(e) => { e.stopPropagation(); editSubTasks(task, index); }} 
                                                            className="w-7 h-7 rounded border border-blue-100 text-blue-500 flex items-center justify-center hover:bg-blue-50 transition-colors bg-white shadow-sm"
                                                        >
                                                            <Edit size={12} strokeWidth={2.5} />
                                                        </button>
                                                        <button 
                                                            onClick={(e) => { e.stopPropagation(); deleteSubTasks(index); }} 
                                                            className="w-7 h-7 rounded border border-red-100 text-red-500 flex items-center justify-center hover:bg-red-50 transition-colors bg-white shadow-sm"
                                                        >
                                                            <Trash2 size={12} strokeWidth={2.5} />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                            {isExpanded && (
                                                <tr className="bg-slate-50 border-b border-slate-200 shadow-[inset_0_1px_3px_rgba(15,23,42,0.06)]">
                                                    <td colSpan="7" className="py-4 px-6">
                                                        <span className="text-[11px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Description</span>
                                                      <div
  className="editor-content text-[14px] [&_*]:text-[14px] text-slate-700 leading-relaxed"
  dangerouslySetInnerHTML={{ __html: task.description }}
/>
                                                    </td>
                                                </tr>

                                            )}
                                            </React.Fragment>
                                        )})}
                                    </tbody>
                                </table>
                            </div>
                      
                        </>
                    ) : (
                        <div className="flex flex-col items-center justify-center flex-1 pb-6 px-4 w-full h-full">
                            {isCurrentDateSubmitted ? (
                                 <div className="flex flex-col items-center justify-center h-full px-6">
        {/* Success Icon */}
        <div className="w-16 h-16 rounded-full bg-emerald-50 border border-emerald-100 flex items-center justify-center mb-5">
            <CheckCircle2
                className="w-9 h-9 text-emerald-500"
                strokeWidth={1.8}
            />
        </div>

        {/* Title */}
        <h3 className="text-lg font-semibold text-slate-800 text-center mb-2">
            DSR Submitted Successfully
        </h3>

        {/* Description */}
        <p className="text-sm text-slate-500 text-center max-w-md leading-6">
            Your daily status report has been submitted for{" "}
            <span className="font-medium text-slate-700">
                {!state.inputDate
                    ? "today"
                    : moment(state.inputDate).isSame(moment(), "day")
                    ? "today"
                    : moment(state.inputDate).format("DD MMM YYYY")}
            </span>
            .
        </p>

        {/* Status */}
        <div className="mt-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-50 text-emerald-600 text-xs font-medium">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
            Submitted
        </div>
    </div>
                            ) : (
                                <div className="flex flex-col items-center justify-center h-full px-6">
                                    <div className="w-16 h-16 rounded-full bg-orange-50 border border-orange-100 flex items-center justify-center mb-5">
                                        <ClipboardList className="w-8 h-8 text-orange-500 opacity-80" strokeWidth={1.8} />
                                    </div>
                                    <h3 className="text-lg font-semibold text-slate-800 text-center mb-2">
                                        {!state.inputDate ? "Plan your tasks" : moment(state.inputDate).isSame(moment(), 'day') ? "Plan your tasks for the day" : `Plan your tasks for ${moment(state.inputDate).format('DD MMM YYYY')}`}
                                    </h3>
                                    <p className="text-sm text-slate-500 text-center max-w-md leading-6 mb-6">
                                        Add tasks to track your progress and stay productive.
                                    </p>
                                    <button
                                        disabled={loading}
                                        onClick={() => modalOpen(setModalHeading("Add"))}
                                        className="px-5 py-2.5 text-white text-[13px] font-bold rounded-xl flex items-center gap-2 transition-all bg-blue-600 hover:bg-blue-700 shadow-sm shadow-blue-600/20"
                                    >
                                        <Plus size={16} strokeWidth={2.5} /> Add Task
                                    </button>
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {/* Bottom Actions Area */}
                {state.dsr && state.dsr.length > 0 && (
                    <div className="mt-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 bg-blue-50/50 p-4 rounded-xl border border-blue-100/50">
                        <div className="flex flex-col text-[12px]">
                            <p className="text-blue-800 mb-0.5"><span className="font-bold">Note:</span> Click on edit to update your task details.</p>
                            <p className="text-blue-600">Don't forget to submit your daily status.</p>
                        </div>
                        
                        <div className="flex items-center gap-3 w-full sm:w-auto">
                            {state.type === "edit" ? (
                                <button 
                                    type="button"  
                                    className="px-5 py-2 text-[13px] bg-white text-slate-700 rounded-lg hover:bg-slate-50 transition-colors font-bold border border-slate-200 flex items-center gap-2 shadow-sm"
                                    onClick={handleCancelEdit}
                                    disabled={loading}
                                >
                                    <X size={16} strokeWidth={2.5} /> Cancel Edit
                                </button>
                            ) : (
                                <button 
                                    type="button"  
                                    disabled={loading}
                                    onClick={() => setClearModal(true)}
                                    className="px-4 py-2 text-slate-600 text-[13px] font-bold rounded-lg border border-slate-200 hover:bg-slate-50 transition-colors flex items-center gap-2"
                                >
                                    <Eraser size={16} strokeWidth={2.5} /> Clear
                                </button>
                            )}
                            
                          <button
                              type="button"
                              className="flex items-center justify-center gap-2 px-6 py-2 bg-blue-600 text-white text-[13px] rounded-lg hover:bg-blue-700 transition-all font-bold shadow-sm shadow-blue-600/20 disabled:opacity-70 disabled:cursor-not-allowed"
                              onClick={sendDsr}
                              disabled={loading}
                          >
                              {loading ? (
                                  <>
                                      <Loader2 size={16} strokeWidth={2.5} className="animate-spin" />
                                      <span>Submitting...</span>
                                  </>
                              ) : (
                                  <>
                                      <Send size={16} strokeWidth={2.5} />
                                      <span>Submit</span>
                                  </>
                              )}
                          </button>
                        </div>
                    </div>
                )}
            </div>
            )}
        </div>

      <SubmitDsrConfirmDialog
        isOpen={showConfirm}
        onClose={() => setShowConfirm(false)}
        onConfirm={executeSendDsr}
        title={confirmTitle}
        message={confirmMessage}
        isLoading={loading}
      />
      
      <ActionConfirmModal
        isOpen={deleteModal.isOpen}
        onClose={() => setDeleteModal({ isOpen: false, index: null })}
        onConfirm={() => { executeDeleteSubTask(deleteModal.index); setDeleteModal({ isOpen: false, index: null }); }}
        title="Delete Task"
        message="Are you sure you want to delete this task? This action cannot be undone."
        confirmText="Delete"
        loading={false}
      />

      <ActionConfirmModal
        isOpen={clearModal}
        onClose={() => setClearModal(false)}
        onConfirm={() => { resetTasks(); setClearModal(false); }}
        title="Clear All Tasks"
        message="Are you sure you want to clear all tasks from your DSR? This action cannot be undone."
        confirmText="Clear All"
        loading={false}
      />

      <AddTaskModal
        isOpen={modal}
        onClose={() => setModal(false)}
        onSave={AddSubTask}
        modalHeading={modalHeading}
        projects={projects}
        taskTypeOptions={taskTypeOptions}
        taskTypeMap={taskTypeMap}
        initialData={modalHeading === "Edit" ? subTaskArray[index] : null}
        selectedDate={state.inputDate}
      />
    </div>
  );
}
